import styles from './index.module.scss';
import PaySlipTable from './Table';

type PaySlipProps = {
	selectedPayrollId: string;
	onlyView: boolean;
	headerData: any;
	usdCurrency: any;
	setIsUniversalLoading: any;
	showSteps: boolean;
};
const PaySlipComponent = (props: PaySlipProps) => {
	const {
		selectedPayrollId,
		onlyView,
		headerData,
		usdCurrency,
		setIsUniversalLoading,
		showSteps,
	} = props;

	return (
		<>
			<div className={styles['pay-Slip__table']}>
				<PaySlipTable
					selectedPayrollId={selectedPayrollId}
					onlyView={onlyView}
					usdCurrency={usdCurrency}
					setIsUniversalLoading={setIsUniversalLoading}
					headerData={headerData}
					showSteps={showSteps}
				/>
			</div>
		</>
	);
};

export default PaySlipComponent;
